<template>
  <div class="base-height_fullscreen">
    <div class="base-flex base-width_fullscreen base-flex__between base-margin__bottom-10">
      <el-button type="primary" @click="openTemplateForm('add', templateForm)">{{
        $t('computingCluster.templateManagement.createTemplate')
      }}</el-button>
      <div>
        <el-select
          v-model="region"
          :placeholder="$t('computingCluster.imagesManage.selectRegion')"
          class="base-width__240"
          @change="getTemplateList"
        >
          <el-option v-for="item in regionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-button
          class="refresh dialogTrueCls base-text-align__right"
          icon="el-icon-refresh"
          :title="$t('common.refresh')"
          type="text"
          @click="getTemplateList"
        ></el-button>
      </div>
    </div>
    <el-table :data="tableData" v-loading="tableLoading" class="template_table">
      <el-table-column prop="id" label="ID" width="180"> </el-table-column>
      <el-table-column prop="name" :label="$t('computingCluster.templateManagement.templateName')" width="180">
      </el-table-column>
      <el-table-column prop="imageId" :label="$t('computingCluster.templateManagement.imageId')" width="180">
      </el-table-column>
      <el-table-column :label="$t('computingCluster.templateManagement.region')">
        <template slot-scope="scope">
          {{ filterRegionList(scope.row.region) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('computingCluster.templateManagement.diskType')">
        <template slot-scope="scope">
          {{ handleCbs(scope.row.diskType) }}
        </template>
      </el-table-column>
      <el-table-column prop="diskSize" :label="$t('computingCluster.templateManagement.diskSize')"> </el-table-column>
      <el-table-column :label="$t('computingCluster.templateManagement.hyperThreading')">
        <template slot-scope="scope">
          {{ scope.row.hyperThreading ? $t('common.on') : $t('common.off') }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('computingCluster.templateManagement.createTime')">
      </el-table-column>
      <el-table-column fixed="right" :label="$t('common.operation')" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openTemplateForm('edit', scope.row)">{{
            $t('common.edit')
          }}</el-button>
          <el-button type="text" size="small" @click="deleteTemplate(scope.row.id)">{{
            $t('common.delete')
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <el-pagination
      :page-size="10"
      :page-sizes="[10, 20, 50, 100]"
      :total="tableDataTotal"
      align="right"
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="onCurrentChange"
    >
    </el-pagination>

    <!-- 模板管理框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="templateFormDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
      @close="closeTemplateFormDialog"
    >
      <div>
        <el-form
          ref="templateForm"
          label-position="left"
          :model="templateForm"
          label-width="80px"
          v-loading="formLoading"
        >
          <el-form-item :label="$t('customCluster.customList.templateName')">
            <el-input
              v-model="templateForm.name"
              maxlength="32"
              :placeholder="$t('customCluster.customList.templateNameRequired')"
            ></el-input>
          </el-form-item>

          <!-- 地域选择表单项 -->
          <el-form-item :label="$t('createNode.region')">
            <el-row>
              <el-col :span="12">
                <el-form-item class="form__item-margin base-margin__right-10">
                  <el-select
                    v-model="templateForm.region"
                    :placeholder="$t('createNode.selectMachineRegion')"
                    class="select-width"
                    @change="selectRegion"
                  >
                    <!-- 遍历地域选项 -->
                    <el-option
                      v-for="item in regionList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <el-select
                    v-model="templateForm.zone"
                    :placeholder="$t('createNode.selectZone')"
                    class="base-margin__right-10"
                    @change="selectZone"
                    filterable
                  >
                    <el-option v-for="item in zoneList" :key="item.ZoneId" :label="item.ZoneName" :value="item.Zone" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>

          <!-- 机器型号表单项 -->
          <el-form-item :label="$t('createNode.machineModel')">
            <el-row>
              <el-col :span="12">
                <!-- 服务器机型选择 -->
                <el-form-item class="form__item-margin base-margin__right-10">
                  <el-select
                    v-model="templateForm.instanceType"
                    :placeholder="$t('createNode.selectServerModel')"
                    filterable
                    @change="selectInstanceType"
                  >
                    <!-- 遍历机型选项 -->
                    <el-option
                      v-for="item in instanceList"
                      :key="item.instanceFamily"
                      :label="item.text"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!-- 服务器配置选择 -->
                <el-form-item class="form__item-margin">
                  <el-select
                    v-model="templateForm.auditor"
                    :placeholder="$t('createNode.selectServerConfig')"
                    filterable
                  >
                    <!-- 遍历配置选项，带详细信息的tooltip -->
                    <el-option
                      v-for="item in instanceDescriptionList"
                      :key="item.value"
                      :disabled="item.disabled"
                      :label="item.text"
                      :value="item.value"
                    >
                      <div class="base-flex__between base-flex__cross-center">
                        <span>{{ item.text }}</span>
                        <el-tooltip offset="20" placement="right" popper-class="tooltipBox">
                          <div slot="content">
                            <p>{{ $t('createNode.vCPU') }}: {{ item.vCpu || '-' }}{{ $t('createNode.core') }}</p>
                            <p>{{ $t('createNode.memory') }}: {{ item.memory || '-' }}GiB</p>
                            <p>{{ $t('createNode.processorFrequency') }}: {{ item.frequency || '-' }}</p>
                            <p>{{ $t('createNode.processorModel') }}: {{ item.cpuType || '-' }}</p>
                            <p>{{ $t('createNode.internalBandwidth') }}: {{ item.instanceBandwidth || '-' }}Gbps</p>
                            <p>
                              {{ $t('createNode.networkPackets') }}: {{ item.instancePps || '-'
                              }}{{ $t('createNode.tenThousandPPS') }}
                            </p>
                          </div>
                          <i class="el-icon-warning-outline base-text-align__right" />
                        </el-tooltip>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>

          <!-- 镜像选择表单项 -->
          <el-form-item :label="$t('createNode.image')">
            <div class="base-width_fullscreen">
              <div class="base-flex base-margin__bottom-10">
                <el-select
                  v-model="templateForm.imageType"
                  :placeholder="$t('createNode.selectImageType')"
                  class="formItem__select-short base-margin__right-20"
                  @change="changeImageType('imageType')"
                >
                  <el-option :label="$t('createNode.sharedImages')" value="SHARED_IMAGE"></el-option>
                  <el-option :label="$t('createNode.privateImages')" value="PRIVATE_IMAGE"></el-option>
                </el-select>
                <el-select
                  v-model="templateForm.imagePlatformType"
                  :placeholder="$t('createNode.selectImageType')"
                  class="formItem__select-short base-margin__right-20"
                  @change="changeImageType('imagePlatform')"
                >
                  <el-option
                    v-for="item in imageTypeList"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <el-select
                v-model="templateForm.imageId"
                :placeholder="$t('createNode.selectImage')"
                class="select-width"
                filterable
                @change="selectImageType"
              >
                <!-- 遍历镜像选项 -->
                <el-option v-for="item in imageList" :key="item.value" :label="item.text" :value="item.value">
                  <el-tooltip class="item" :open-delay="100" effect="dark" placement="bottom">
                    <template slot="content">
                      <span>
                        <p>镜像名称: {{ item.text }}</p>
                        <p>镜像ID: {{ item.value }}</p>
                        <p>系统盘容量: {{ item.size }}GiB</p>
                        <p>操作系统: {{ item.osName }}</p>
                      </span>
                    </template>
                    <span>{{ item.text }} | {{ item.value }}</span>
                  </el-tooltip>
                </el-option>
              </el-select>
            </div>
          </el-form-item>

          <!-- 系统盘表单项 -->
          <el-form-item :label="$t('createNode.systemDisk')">
            <el-row>
              <el-col :span="12">
                <!-- 磁盘类型选择 -->
                <el-form-item class="form__item-margin base-margin__right-10">
                  <el-select
                    v-model="templateForm.diskType"
                    :placeholder="$t('createNode.selectSystemDisk')"
                    class="base-margin__right-20"
                  >
                    <el-option
                      v-for="item in diskList"
                      :key="item.key"
                      :label="`${item.key} | ${item.remark}`"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!-- 磁盘大小输入 -->
                <el-form-item class="form__item-margin">
                  <el-input-number v-model="templateForm.diskSize" :min="gibMinNumber" style="width: 150px" />
                  GIB
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>

          <!-- 超线程设置表单项 -->
          <el-form-item :label="$t('createNode.hyperThreading')">
            <el-checkbox v-model="templateForm.hyperThreading" @change="changeHyperThreading">
              <el-popover
                placement="bottom"
                title="提示"
                width="300"
                trigger="click"
                content="您已选择关闭超线程功能。此操作需要提前联系腾讯云客服申请白名单权限，否则实例将保持默认超线程设置"
                v-model="popoverVisible">
                  <span slot="reference">
                    {{ $t('createNode.disableHyperThreading') }}
                  </span>
              </el-popover>
            </el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="templateFormDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="doneTemplateManage">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postRequest } from '@/common/libs/request';
import { regionList, filterRegionList } from '@/common/utils/utils';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'templateManage',
  data() {
    return {
      tableLoading: false, // 表格加载状态
      formLoading: false, // 表单加载状态
      pageIndex: 1, // 分页index
      pageLimit: 10, // 每一页条数
      tableDataTotal: 0, // 任务总数
      regionList,
      region: 'ap-nanjing',
      tableData: [],
      templateFormDialogVisible: false, // 模板弹窗
      dialogTitle: this.$t('computingCluster.templateManagement.createTemplate'),
      templateForm: {
        name: '',
        region: '',
        imageType: 'SHARED_IMAGE',
        imageId: '',
        instanceType: '',
        auditor: '',
        diskType: '',
        diskSize: 0,
        hyperThreading: false,
        imagePlatformType: '',
      },
      imageList: [], // 镜像列表
      zoneList: [], // 区域列表
      instanceList: [], // 实例列表
      defaultInstanceList: null, // 默认实例列表
      instanceDescriptionList: [], // 实例描述列表
      diskList: [], // 磁盘列表
      gibMinNumber: 0, // 磁盘最小值
      imageSize: 0, // 镜像大小
      filterRegionList, // 过滤地区列表
      imageTypeList: [], // 镜像类型列表
      popoverVisible: false, // 弹出框可见性
    };
  },

  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject'() {
      const currentProject = this.getCurrentProject();
      this.region = currentProject?.masterNode?.region || 'ap-nanjing';
      this.pageLimit = 10;
      this.pageIndex = 1;
      this.tableDataTotal = 0;
      this.getTemplateList();
    },
  },

  created() {
    const currentProject = this.getCurrentProject();
    this.region = currentProject?.masterNode?.region || 'ap-nanjing';
  },

  mounted() {
    this.getTemplateList();
  },

  methods: {
    // js函数

    /**
     * 切换超线程
     */
    changeHyperThreading() {
      if (this.templateForm.hyperThreading) {
        this.popoverVisible = true;
      } else {
        this.popoverVisible = false;
      }
    },
    // 打开模板弹窗
    openTemplateForm(type, data) {
      if (type === 'edit') {
        this.dialogTitle = this.$t('computingCluster.templateManagement.editTemplate');
        this.templateForm = JSON.parse(JSON.stringify(data));
        this.templateForm.auditor = data.instanceType;
        this.templateForm.hyperThreading = data.hyperThreading === 0;
        this.selectRegion();
        this.selectZone();
        setTimeout(() => {
          this.selectImageType(type);
        }, 500);
      } else {
        this.dialogTitle = this.$t('computingCluster.templateManagement.createTemplate');
      }
      this.templateForm.imagePlatformType = '';
      this.templateFormDialogVisible = true;
    },

    // 选择地区  获取镜像列表 获取区域列表
    selectRegion() {
      this.getImageList();
      this.getZoneList();
    },

    /**
     * 选择镜像类型
     */
    changeImageType(type) {
      this.templateForm.imageId = '';
      if (type === 'imageType') {
        this.templateForm.imagePlatformType = '';
        this.getImageList();
      } else {
        if (this.templateForm.imagePlatformType === '') {
          this.imageList = this.imageOptionList;
        } else {
          this.imageList = this.imageOptionList.filter(item => item.platform === this.templateForm.imagePlatformType);
        }
      }
    },

    // 选择区域 获取实例列表
    selectZone() {
      this.getInstanceList();
    },

    // 选择镜像
    selectImageType(type) {
      const imageSize = this.imageList.find(item => item.value === this.templateForm.imageId)?.size || 0;
      this.gibMinNumber = imageSize;
      if (type !== 'edit') {
        this.templateForm.diskSize = imageSize;
      }
    },

    // 获取镜像列表
    getImageList() {
      this.formLoading = true;
      const param = {
        region: this.templateForm.region,
        tags: ['openeda:'],
        imageType: this.templateForm.imageType,
      };
      this.templateForm.imagePlatformType = '';
      postRequest('/api/eda/common/eda/getImageList', param)
        .then((res) => {
          this.imageOptionList = [];
          this.imageList = [];
          const platformSet = new Set();
          platformSet.add(''); // 添加"全部"选项
          res?.list.forEach((item) => {
            this.imageList.push({
              text: item.name,
              value: item.value,
              size: item.disk,
              platform: item.platform,
              osName: item.osName,
            });
            platformSet.add(item.platform);
          });
          this.imageOptionList = this.imageList;
          this.imageTypeList = Array.from(platformSet).map(platform => ({
            text: platform === '' ? this.$t('common.all') : platform,
            value: platform,
          }));
          this.formLoading = false;
        })
        .catch(() => {
          this.formLoading = false;
        });
    },

    /**
     * 获取区域列表
     */
    getZoneList() {
      this.zoneList = [];
      this.formLoading = true;
      postRequest('/api/eda/common/tencentcloud/describeZones', {
        region: this.templateForm.region,
      }).then((res) => {
        this.zoneList = res.zoneSet;
        this.formLoading = false;
      });
    },

    /**
     * 获取磁盘类型
     * @param {String} instanceFamily 实例家族
     */
    getDisk(instanceFamily) {
      if (this.templateForm.region === '') return;
      this.formLoading = true;
      this.diskList = [];
      postRequest('/api/eda/common/tencentcloud/describeDiskType', {
        region: this.templateForm.region,
        zone: this.templateForm.zone,
        cvmInstanceFamily: [instanceFamily],
      }).then((res) => {
        if (res.diskTypeSet == null || res.diskTypeSet.length === 0) {
          this.templateForm.diskType = '';
          this.templateForm.diskSize = '';
          this.formLoading = false;
          return this.$message.error(this.$t('createNode.noAvailableDisk'));
        }
        this.diskList = res.diskTypeSet;
        const newArr = [];
        this.diskList.forEach((item) => {
          const newObj = {
            key: this.handleCbs(item.disk_type),
            value: item.disk_type,
            minSize: item.disk_size.min_size,
            remark: item.overall_performance || '',
          };
          newArr.push(newObj);
        });

        this.diskList = newArr;
        this.templateForm.diskType = this.diskList[0].value;
        this.formLoading = false;
      });
    },

    /**
     * 处理磁盘类型显示
     * @param {String} diskType 磁盘类型
     * @returns {String} 显示文本
     */
    handleCbs(diskType) {
      switch (diskType) {
        case 'CLOUD_BASIC':
          return this.$t('createNode.cloudBasic');
        case 'CLOUD_PREMIUM':
          return this.$t('createNode.cloudPremium');
        case 'CLOUD_BSSD':
          return this.$t('createNode.cloudBssd');
        case 'CLOUD_SSD':
          return this.$t('createNode.cloudSsd');
        case 'CLOUD_HSSD':
          return this.$t('createNode.cloudHssd');
        case 'CLOUD_TSSD':
          return this.$t('createNode.cloudTssd');
        default:
          return '';
      }
    },

    /**
     * 删除模板
     * @param {String} templateId 模板ID
     */
    deleteTemplate(templateId) {
      this.$confirm('确定删除当前模板吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          postRequest('/api/eda/common/cluster/delTemplate', {
            id: templateId,
          }).then(() => {
            this.$message.success('删除模板成功！');
            this.pageIndex = 1; // 分页index
            this.pageLimit = 10; // 每一页条数
            this.tableDataTotal = 0; // 任务总数
            this.getTemplateList();
          });
        })
        .catch(() => {
          // 取消删除操作
        });
    },

    /**
     * 获取实例列表
     */
    getInstanceList() {
      this.formLoading = true;
      postRequest('/api/eda/common/eda/getInstanceList', {
        region: this.templateForm.region,
        zone: this.templateForm.zone,
      }).then((res) => {
        this.getInstance(res.InstanceList);
      });
    },

    /**
     * 获取实例列表
     * @param {Array} res 响应数据
     */
    getInstance(res) {
      const cvmMapPostpaidByHour = new Map();

      // 根据机型去重
      const cvmNonredundantPostpaidByHourMap = new Map();

      res.forEach((cvm) => {
        if (cvm.InstanceChargeType === 'POSTPAID_BY_HOUR') {
          cvmNonredundantPostpaidByHourMap.set(cvm.InstanceType, cvm);
        }
      });

      // 构造按量计费结构
      for (const cvm of cvmNonredundantPostpaidByHourMap.values()) {
        if (cvmMapPostpaidByHour.has(cvm.TypeName)) {
          cvmMapPostpaidByHour.get(cvm.TypeName).push(cvm);
        } else {
          cvmMapPostpaidByHour.set(cvm.TypeName, [cvm]);
        }
      }

      this.defaultInstanceList = [cvmMapPostpaidByHour];
      this.selectInstanceChargeType('POSTPAID_BY_HOUR');
    },

    /**
     * 选择实例计费类型
     * @param {String} type 计费类型
     */
    selectInstanceChargeType(type) {
      const instanceTypeList = [];
      let cvmsDataMap;

      if (type === 'POSTPAID_BY_HOUR') {
        [cvmsDataMap] = this.defaultInstanceList;
      }

      // 构造服务器机型选项
      if (cvmsDataMap) {
        for (const key of cvmsDataMap.keys()) {
          const typeOption = {
            value: key,
            text: key,
          };
          instanceTypeList.push(typeOption);
        }
      }

      this.instanceList = instanceTypeList;
      this.formLoading = false;

      const value = this.templateForm.instanceType;

      for (const cvm of this.defaultInstanceList[0].values()) {
        cvm.forEach((item) => {
          if (value === item.InstanceType) {
            this.templateForm.instanceType = item.TypeName;
          }
        });
      }

      this.selectInstanceType();
    },

    /**
     * 选择实例计费类型
     */
    selectInstanceType() {
      const value = this.templateForm.instanceType;

      for (const cvm of this.defaultInstanceList[0].values()) {
        cvm.forEach((item) => {
          if (value === item.InstanceType) {
            this.templateForm.instanceType = item.InstanceType;
          }
        });
      }
      const instanceDescriptionList = [];
      let cvmsDataMap = new Map();
      if (this.templateForm.instanceType) {
        [cvmsDataMap] = this.defaultInstanceList;

        // 构造服务器配置选项
        for (const cvm of cvmsDataMap.get(this.templateForm.instanceType)) {
          let description = `${cvm.Cpu}${this.$t('createNode.core')}${cvm.Memory}GB ${cvm.Remark} | ${
            cvm.InstanceType
          }`;
          let disabled = false;
          if (cvm.Status === 'SOLD_OUT') {
            description = `${description}(${this.$t('createNode.soldOut')})`;
            disabled = true;
          }

          const descriptionOption = {
            value: cvm.InstanceType,
            text: description,
            disabled,
            instanceFamily: cvm.InstanceFamily,
            vCpu: cvm.Cpu,
            memory: cvm.Memory,
            frequency: cvm.Frequency,
            cpuType: cvm.CpuType,
            instanceBandwidth: cvm.InstanceBandwidth,
            networkCard: cvm.NetworkCard,
            instancePps: cvm.InstancePps,
          };
          instanceDescriptionList.push(descriptionOption);
        }
      }
      this.getDisk(instanceDescriptionList[0]?.instanceFamily || '');
      this.instanceDescriptionList = instanceDescriptionList;
    },

    // 确认模板
    doneTemplateManage() {
      postRequest('/api/eda/common/cluster/setTemplate', {
        ...this.templateForm,
        hyperThreading: this.templateForm.hyperThreading ? 0 : 1,
        instanceType: this.templateForm.auditor,
      }).then(() => {
        this.$message.success('模板设置成功！');
        this.templateFormDialogVisible = false;
        this.getTemplateList();
      });
    },

    // 关闭模板弹窗
    closeTemplateFormDialog() {
      this.templateForm = {
        name: '',
        region: '',
        imageType: 'SHARED_IMAGE',
        imageId: '',
        instanceType: '',
        auditor: '',
        diskType: '',
        diskSize: 0,
        hyperThreading: false,
      };
      this.gibMinNumber = 0;
      this.$refs.templateForm.clearValidate();
    },

    /**
     * 分页器钩子函数 页数修改时触发
     * @param val 页数
     */
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getTemplateList();
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(val) {
      this.pageLimit = val;
      this.pageIndex = 1;
      this.getTemplateList();
    },
    // 获取模板列表
    getTemplateList() {
      this.tableLoading = true;
      const offset = this.pageLimit * (this.pageIndex - 1);
      postRequest('/api/eda/common/cluster/describeTemplateList', {
        region: this.region,
        Offset: offset,
        limit: this.pageLimit,
      })
        .then((res) => {
          this.tableData = res?.list || [];
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
// table 背景颜色+padding10px
.template_table {
  width: 100%;
  height: calc(100% - 120px);

  ::v-deep .el-table__body-wrapper {
    height: calc(100% - 48px);
    overflow-y: auto;
  }
}

.pagination {
  padding: 20px 10px;
  background: #fff;
  text-align: right;

  ::v-deep .el-pagination__total {
    float: left;
  }
}

.refresh {
  padding: 0;
  font-size: 20px;
  margin-left: 10px;
}
</style>
